import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import { getBrandImage, getProductPhoto } from '../../data/brandImages';
import { FEATURED_BENEFITS, BENEFIT_CATEGORIES } from '../../data/siteContent';
import { BrandStrip } from './ClientLayout';
import { PageHero } from './HomePage';
import { formatRewardDeal } from '../../utils/loyalty';

const BenefitsPage = ({ setCurrentView, siteConfig }) => {
  const [rewards, setRewards] = useState([]);
  const [category, setCategory] = useState('all');

  useEffect(() => {
    const load = async () => {
      try {
        const q = query(collection(db, 'beneficios'), where('activo', '==', true));
        const snap = await getDocs(q);
        setRewards(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (e) {
        setRewards([]);
      }
    };
    load();
  }, []);

  const filtered = category === 'all'
    ? rewards
    : rewards.filter((r) => (r.category || '').toLowerCase() === category);

  return (
    <div>
      <PageHero
        image={getBrandImage(siteConfig, 'heroBeneficios')}
        title={
          <>
            Beneficios que hacen cada momento más rico
          </>
        }
        subtitle="Promos, experiencias y sorpresas pensadas especialmente para vos."
        scripts={['La buena comida siempre une']}
      />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-wrap gap-2 mb-8">
          {BENEFIT_CATEGORIES.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setCategory(cat.id)}
              className={`h-9 px-4 rounded-full text-sm font-extrabold ${
                category === cat.id ? 'bg-maja-red text-white' : 'bg-gray-100 text-gray-700'
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {filtered.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {filtered.map((reward, i) => (
              <button
                key={reward.id}
                onClick={() => setCurrentView('canjes')}
                className="relative h-56 rounded-2xl overflow-hidden text-left group"
              >
                <img
                  src={reward.image || getProductPhoto(i)}
                  alt={reward.nombre}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4 text-white">
                  <h3 className="font-black text-xl">{reward.nombre}</h3>
                  <p className="text-sm text-white/80 mt-1">
                    {formatRewardDeal(reward)}
                  </p>
                </div>
              </button>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {FEATURED_BENEFITS.map((item) => (
              <button
                key={item.title}
                onClick={() => setCurrentView('canjes')}
                className="relative h-56 rounded-2xl overflow-hidden text-left group"
              >
                <img
                  src={getBrandImage(siteConfig, item.imageKey)}
                  alt={item.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4 text-white">
                  <h3 className="font-black text-xl">{item.title}</h3>
                  <p className="text-sm text-white/80 mt-1">{item.text}</p>
                </div>
              </button>
            ))}
          </div>
        )}
      </section>

      <BrandStrip
        setCurrentView={setCurrentView}
        title="Más beneficios, más momentos, más Maja Club."
        cta="Ver canjes"
        target="canjes"
      />
    </div>
  );
};

export default BenefitsPage;
